// this is the mechanism by which we get and register globals:

const registeredGlobals = {};

const initGlobalByKey = (key, value)=> {
  registeredGlobals[key] = value;
};
const getGlobalByKey = (key)=> {
  if (registeredGlobals[key] === undefined) {
    throw new Error(`Must init global value "${key}" before it can be accessed`);
  }
  return registeredGlobals[key];
};

// these are the specific global objects we use at present:

const initPageActivityTrackerGlobal = (pageActivityTracker) =>
  initGlobalByKey('pageActivityTracker', pageActivityTracker);

const getTracker = () =>
  getGlobalByKey('pageActivityTracker');

const initReduxStoreGlobal = (reduxStore) =>
  initGlobalByKey('reduxStore', reduxStore);

const getReduxStore = () =>
  getGlobalByKey('reduxStore');

const initRouterGlobal = (router) =>
  initGlobalByKey('router', router);

const getRouter = () =>
  getGlobalByKey('router');

export {
  initPageActivityTrackerGlobal,
  getTracker,
  initReduxStoreGlobal,
  getReduxStore,
  initRouterGlobal,
  getRouter
};
